import React from "react";

function Footer() {
  return (
    <footer style={{ backgroundColor: "rgb(250,250,250)" }}>
      <div className="container border-top mt-5">
        <div className="row mt-5 ">
          <div className="col">
            <img src="Media/images/logo.svg" style={{ width: "40%" }} />
            <p>&copy; 2010 - 2025, Zerodha Broking Ltd. All rights reserved.</p>
          </div>
          <div className="col text-muted">
            <p>
              <b>Company</b>
            </p>

            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Products
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Pricing
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Referral programme
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Careers
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Zerodha.tech
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Open source
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Press & media{" "}
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Zerodha Cares (CSR){" "}
            </a>
          </div>
          <div className="col">
            <p>
              <b>Support</b>
            </p>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Contact us
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Support portal
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Z-Connect blog
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              List of charges
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Downloads & resources
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Videos{" "}
            </a>
            <br></br>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Market overview{" "}
            </a>
            <br />
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              How to file a complaint?{" "}
            </a>
            <br />
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Status of your complaints
            </a>
          </div>
          <div className="col">
            <p>
              <b>Account</b>
            </p>
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Open an account
            </a>
            <br />
            <a href="/" style={{ textDecoration: "none", color: "#424242" }}>
              Fund transfer
            </a>
          </div>
        </div>
        <div className="mt-5" style={{ fontSize: "10.4px", color: "#9B9B9B" }}>
          <p>
            Zerodha Broking Ltd.: Member of NSE, BSE​ &​ MCX – SEBI Registration
            no.: INZ000031633 CDSL/NSDL: Depository services through Zerodha
            Broking Ltd. – SEBI Registration no.: IN-DP-431-2019 Commodity
            Trading through Zerodha Commodities Pvt. Ltd. MCX: 46025; NSE-50001
            – SEBI Registration no.: INZ000038238 Registered Address: Zerodha
            Broking Ltd., #153/154, 4th Cross, Dollars Colony, Opp. Clarence
            Public School, J.P Nagar 4th Phase, Bengaluru - 560078, Karnataka,
            India. For any complaints pertaining to securities broking please
            write to
            <a href="/" style={{ textDecoration: "none" }}>
              complaints@zerodha.com
            </a>
            , for DP related to{" "}
            <a href="/" style={{ textDecoration: "none" }}>
              dp@zerodha.com
            </a>
            . Please ensure you carefully read the Risk Disclosure Document as
            prescribed by SEBI | ICF
          </p>
          <p>
            Procedure to file a complaint on{" "}
            <a href="/" style={{ textDecoration: "none" }}>
              SEBI SCORES
            </a>
            : Register on SCORES portal. Mandatory details for filing complaints
            on SCORES: Name, PAN, Address, Mobile Number, E-mail ID. Benefits:
            Effective Communication, Speedy redressal of the grievances
          </p>
          <a href="/" style={{ textDecoration: "none" }}>
            Smart Online Dispute Resolution{" "}
          </a>{" "}
          |{" "}
          <a href="/" style={{ textDecoration: "none" }}>
            Grievances Redressal Mechanism
          </a>
          <br />
          <p>
            Investments in securities market are subject to market risks; read
            all the related documents carefully before investing.
          </p>
          <p>
            Attention investors: 1) Stock brokers can accept securities as
            margins from clients only by way of pledge in the depository system
            w.e.f September 01, 2020. 2) Update your e-mail and phone number
            with your stock broker / depository participant and receive OTP
            directly from depository on your e-mail and/or mobile number to
            create pledge. 3) Check your securities / MF / bonds in the
            consolidated account statement issued by NSDL/CDSL every month.
          </p>
          <p>
            "Prevent unauthorised transactions in your account. Update your
            mobile numbers/email IDs with your stock brokers. Receive
            information of your transactions directly from Exchange on your
            mobile/email at the end of the day. Issued in the interest of
            investors. KYC is one time exercise while dealing in securities
            markets - once KYC is done through a SEBI registered intermediary
            (broker, DP, Mutual Fund etc.), you need not undergo the same
            process again when you approach another intermediary." Dear
            Investor, if you are subscribing to an IPO, there is no need to
            issue a cheque. Please write the Bank account number and sign the
            IPO application form to authorize your bank to make payment in case
            of allotment. In case of non allotment the funds will remain in your
            bank account. As a business we don't give stock tips, and have not
            authorized anyone to trade on behalf of others. If you find anyone
            claiming to be part of Zerodha and offering such services, please{" "}
            <a href="/" style={{ textDecoration: "none" }}>
              create a ticket here.
            </a>
          </p>
        </div>

        <div className="row mb-3 ">
          <div
            className="col-12"
            style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
          >
            <div
              className="text-muted"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  NSE
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  BSE
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  MCX
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  Terms & conditions
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  Policies & procedures
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  Privacy policy
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  Disclosure
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  For investor's attention
                </a>
              </p>
              <p style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                    color: "#9b9b9b",
                    fontSize: "12px",
                  }}
                >
                  Investor charter
                </a>
              </p>
            </div>
            <div />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
